module.exports = __webpack_public_path__ + "img/shipping-fee.6c12f033.png";